<div class="header-container">
    <div class="header-content">
        <div class="header-left-content">
            <img class="sponsor-image" [src]='sponsorLogo' alt="sponsor-logo" (click)="routeToLogin()">
            <div class="sponsor-header">{{headerFooterCMSData?.sponsorName}}</div>
            <div class="powered-header">{{headerFooterCMSData?.poweredByLabel}}</div>
            <div class="gravty-header">{{headerFooterCMSData?.gravtyLabel}}</div>
        </div>
        <div class="header-right-content">
            <div class="nav-container">
                <div class="nav-item" *ngIf="getGenericSettings?.showAboutUsNavigation">
                    <markdown id="nav-content" class="text-here" [data]="headerFooterCMSData?.aboutUsCta"></markdown>
                </div>
                <div class="nav-item" *ngIf="getGenericSettings?.showFaqNavigation">
                    <markdown id="nav-content" class="text-here" [data]="headerFooterCMSData?.faqCta"></markdown>
                </div>
                <div class="nav-item" *ngIf="getGenericSettings?.showContactNavigation">
                    <markdown id="nav-content" class="text-here" [data]="headerFooterCMSData?.contactCta"></markdown>
                </div>
            </div>
            <div class="button-container">
                <app-button [displayText]="headerFooterCMSData?.signinCta" type="guest-signin" fontColor="#2C3241" [height]="42" [width]="98" (clicked)="routeToLogin()"></app-button>
                <app-button [displayText]="headerFooterCMSData?.becomePartnerCta" type="guest-signup" fontColor="#2C3241" [height]="42" [width]="177" (clicked)="routeToSignup()"></app-button>
            </div>
        </div>
    </div>
</div>